export const FORM_MODE_COMPANY = 'company'
export const FORM_MODE_PRIVATE = 'private'
export const DEFAULT_PHONE_CODE = '372'

export default {
  FORM_MODE_COMPANY,
  FORM_MODE_PRIVATE,
  DEFAULT_PHONE_CODE,
}
